export const ORG_INVITE_STATUS_INVITED = 'invited';
export const ORG_INVITE_STATUS_ACCEPTED = 'accepted';
export const ORG_INVITE_STATUS_REMOVED = 'removed';
export const ORG_INVITE_STATUS_DECLINED = 'declined';

export const ORG_INVITE_ACCEPT_SUCCESS = 'success';
export const ORG_INVITE_ACCEPT_FAILED = 'failed';

export const ORG_INVITE_DELETION_PENDING = 'deletion_pending';

export const REQUEST_TO_JOIN_WORKSPACE_REQUESTED = 'requested';
export const REQUEST_TO_JOIN_WORKSPACE_ALREADY_MEMBER = 'already_member';
export const REQUEST_TO_JOIN_WORKSPACE_AUTOJOINED = 'autojoined';
export const REQUEST_TO_JOIN_WORKSPACE_DOMAIN_NOT_ASSOCIATED =
  'domain_not_associated';
export const REQUEST_TO_JOIN_WORKSPACE_ALREADY_REQUESTED = 'already_requested';

export type RequestJoinWorkspaceStatus =
  | 'requested'
  | 'already_member'
  | 'autojoined'
  | 'already_requested'
  | 'domain_not_associated';

export const REQUEST_TO_JOIN_WORKSPACE_STATUSES = [
  REQUEST_TO_JOIN_WORKSPACE_REQUESTED,
  REQUEST_TO_JOIN_WORKSPACE_ALREADY_MEMBER,
  REQUEST_TO_JOIN_WORKSPACE_DOMAIN_NOT_ASSOCIATED,
  REQUEST_TO_JOIN_WORKSPACE_AUTOJOINED,
  REQUEST_TO_JOIN_WORKSPACE_ALREADY_REQUESTED,
];

export const JOIN_SOURCES = {
  ADMIN_TOOL: 'admin-tool',
  AUTO_JOIN: 'auto-join',
  JOIN_REQUEST: 'join-request',
  SSO: 'sso',
  ORG_INVITE: 'org-invite',
  CREATE_ORGANIZATION: 'create-organization',
  HIDDEN_WORKSPACE_CREATION: 'hidden-workspace-creation',
  INVITE_LINK: 'invite-link',
};
